import React, { CSSProperties, SyntheticEvent } from 'react';
import classNames from 'classnames';

import { ChildrenPropType } from 'src/utils/types';

export type UiInnerNotSpaLinkProps = {
  href: string;
  children: ChildrenPropType;

  className?: string;
  onClick?: (e: SyntheticEvent<HTMLAnchorElement>) => void;
  style?: CSSProperties;
  title?: string;
  id?: string;
  dataTest?: string;
  dataTestId?: string;
  disabled?: boolean;
  download?: 'file';
};

/**
 * a component for inner app links (not for React links)
 * prefer this not hardRedirect
 */
export const UiInnerNotSPALink: React.FC<UiInnerNotSpaLinkProps> = ({
  children,
  dataTest,
  dataTestId,
  className,
  disabled,
  ...props
}: UiInnerNotSpaLinkProps) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <a data-test={dataTest} data-testid={dataTestId} className={classNames(className, { disabled })} {...props}>
    {children}
  </a>
);
